import { getStorageItem } from "./utils";
import { logo, support } from "../defaultValues/lead";
import {
  AVIVA_PARTNER_CODE,
  DEFAULT_PARTNER_CODE,
  SLUG_NONPOS,
} from "../constants";

export const buildWrapperTokenHeader = () => {
  return {
    Authorization: `Basic ${btoa(
      `${process.env.REACT_APP_WRAPPER_API_USER}:${process.env.REACT_APP_WRAPPER_API_PASSWORD}`
    )}`,
  };
};

export const buildCustomTokenHeader = () => {
  return {
    "custum-token": getStorageItem("access-token"),
  };
};

export const buildGenerateOtpPayload = (form) => {
  return { mobile: form.mobile, partnerid: getStorageItem("partnerId") };
};

export const buildVerifyOtpPayload = ({ mobile, otp }, checksum) => {
  return {
    mobile,
    checksum,
    otp,
    userCategory: getStorageItem("userType") || SLUG_NONPOS,
    partnercode: getStorageItem("partnerCode") || DEFAULT_PARTNER_CODE,
    partner_branch_code: getStorageItem("partnerBranchCode") || "",
  };
};

export const rebuildBannersList = (data = [], partnerSlug = null) => {
  if (!partnerSlug) {
    return data;
  }

  const filteredList = data.filter(
    (item) => item.partnerSlug.indexOf(partnerSlug) > -1
  );

  return filteredList;
};

export const renderSupportText = (keyname) =>
  support[getStorageItem("partnerCode") ?? DEFAULT_PARTNER_CODE][keyname];

export const renderLogoProperty = (keyname) =>
  logo[getStorageItem("partnerCode")][keyname];
